import { flow, types } from "mobx-state-tree";
import { auth, createUser, logout, profile } from "@/core/api/user";

const $user = types
  .model("$user", {
    isAuth: types.boolean,
    // Сессия уже проверена запросом /profile? До ответа состояние неизвестно:
    // рисовать по isAuth === false форму входа нельзя — она мигнёт на каждой
    // перезагрузке вкладки и тут же сменится контентом.
    checked: types.optional(types.boolean, false),
    role: types.string,
    login: types.string,
    username: types.string,
    // Сессия работает под общей учётной записью. Считается на сервере от
    // config.sharedAccountLogin — фронту логин общей учётки знать неоткуда.
    shared: types.optional(types.boolean, false),
    permissions: types.model("$user.permissions", {
      locales: types.maybe(types.array(types.string)),
      projects: types.maybe(types.array(types.string)),
    }),
  })
  .actions((self) => ({
    setData(data) {
      Object.keys(data).forEach((key) => {
        self[key] = data[key];
      });
    },
    auth: flow(function* ({ login, password }) {
      const { data } = yield auth({ login, password });
      self.isAuth = true;
      self.checked = true;
      self.setData(data);
    }),
    profile: flow(function* () {
      let data;

      // try охватывает только запрос. Если завернуть в него и запись в стор,
      // сбой setData проглотится молча, а isAuth уже успеет стать true —
      // стор останется в состоянии «авторизован, но без данных».
      try {
        ({ data } = yield profile());
      } catch (e) {
        // Не авторизован — остаёмся на форме входа. Без этого catch каждый
        // анонимный заход оставляет «Uncaught (in promise)» в консоли:
        // profile() зовётся из useEffect, и отказ flow никто не ловит.
        self.checked = true;
        return;
      }

      self.isAuth = true;
      self.checked = true;
      self.setData(data);
    }),
    registerPersonal: flow(function* ({ login, username, password }) {
      const { data } = yield createUser({ login, username, password });

      // Сервер уже переключил сессию на новую учётку — остаётся переложить её
      // в стор тем же setData, что и после обычного входа.
      self.setData(data);
    }),
    reset() {
      // checked намеренно не сбрасывается: после 401 или выхода сессия
      // проверена и известно, что её нет — нужна форма входа, а не спиннер.
      self.isAuth = false;
      self.role = "";
      self.login = "";
      self.username = "";
      self.shared = false;
      self.permissions = { locales: [], projects: [] };
    },
    logout: flow(function* () {
      try {
        yield logout();
      } catch (e) {
        // сессия могла протухнуть — состояние всё равно сбрасываем
      }
      self.reset();
    }),
  }))
  .views((self) => ({}))
  .create({
    isAuth: false,
    role: "",
    login: "",
    username: "",
    shared: false,
    permissions: {},
  });

export default $user;
